// @flow
import * as React from "react"
import {containers} from "@swarm2/core"
import _ from "lodash"
import * as Util from "../common"
import MenuItem from "material-ui/MenuItem"
import ContactIcon from "react-icons/lib/fa/comment"
import "./freshdesk-ticket-button.css"

const M = Util.intlMessages("view.NavLayout")

export function NavItem(props: Object) {
  const {name, children, icon, ...attrs} = props
  const hidden = props.hidden || false // no destructuring because flow is obnoxious
  // Picky formatting here. <MenuItem disabled> breaks the fade-in, but
  // <MenuItem style:hidden> shows the wrong cursor while hidden. Wrapper div
  // gets both the cursor and fade-in right.
  return (
    <div style={{visibility: hidden ? "hidden" : ""}}>
      <MenuItem
        style={{
          opacity: hidden ? 0 : 1,
          transition: "opacity 500ms ease-in",
        }}
        className="navMenuItem"
        leftIcon={icon}
        {...attrs}
      >
        {children}
      </MenuItem>
    </div>
  )
}
function FreshdeskTicketButtonRender(props) {
  if (props.isError) return <Util.Error inline error={props} />
  const {debugProps, isDebug, freshdesk} = props
  // flag to disable this button
  if (!freshdesk) return null
  // loading, or in unit tests
  if (!(window && window.FreshWidget)) {
    return (
      <span title="window.FreshWidget">
        <Util.LoadingSpinner />
      </span>
    )
  }
  // This is all formatting specific to freshdesk. No point in moving it to core - not going to unittest it.
  // Be careful, freshdesk fields evaluate HTML and have potential for XSS.
  if (isDebug) {
    debugProps.debug_xssTest = "<script>alert(/ohno/)</script>"
  }
  // `val` is user data - escape to guard against XSS.
  const debugText = _.map(
    debugProps,
    (val, key) => "<li>" + key + ": " + _.escape(val),
  ).join("")
  const body =
    "Enter your message here.<br><br><br><br>---<br>Debug information (don't touch):<br><ul>" +
    debugText +
    "</ul>"
  window.FreshWidget.init("", {
    // Prepopulate the body. https://support.freshdesk.com/support/articles/154064-pre-populating-feedback-widget-form
    queryString:
      "&widgetType=popup&formTitle=Feedback+and+Bug+Reports&submitThanks=Thank+you!" +
      "&helpdesk_ticket[description]=" +
      encodeURIComponent(body),
    loadOnEvent: "immediate",
    // everything below is copypasted from their create-a-widget form
    // https://swarmsim.freshdesk.com/admin/widget_config
    utf8: "✓",
    widgetType: "popup",
    buttonType: "text",
    buttonText: "Send feedback",
    buttonColor: "white",
    buttonBg: "#4A148C",
    alignment: "3",
    offset: "50px",
    submitThanks: "Thank you!",
    formHeight: "500px",
    url: "https://swarmsim.freshdesk.com",
  })
  return (
    <NavItem
      name="contact"
      icon={<ContactIcon />}
      onClick={window.FreshWidget.show}
    >
      <M id="contact" />
    </NavItem>
  )
}
export default containers.nav.FreshdeskTicketButton(FreshdeskTicketButtonRender)



// WEBPACK FOOTER //
// ./src/nav/FreshdeskTicketButton.js